// @ts-nocheck
import * as React from "react";

const CartPlusLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M8.56 19.461a1.5 1.5 0 1 1-2.12 2.122 1.5 1.5 0 0 1 2.12-2.122Zm10 0a1.5 1.5 0 1 1-2.12 2.122 1.5 1.5 0 0 1 2.12-2.122ZM5 4.022a1 1 0 0 1 1 .74l.58 2.26h4.441a6.5 6.5 0 0 0 .489 2H7.13l1.63 6h7.62L17.391 13a6.506 6.506 0 0 0 2.455-.437l-1.956 3.91a1 1 0 0 1-.89.55H8a1 1 0 0 1-1-.74L4.24 6.022H3a1 1 0 1 1 0-2ZM17.504 1.3l.221.005a5.201 5.201 0 0 1 4.975 5.2l-.005.22a5.2 5.2 0 1 1-5.415-5.42l.224-.005ZM17.5 2.7a3.8 3.8 0 0 0-.005 7.6l.195-.005a3.8 3.8 0 0 0 3.61-3.79l-.005-.195A3.8 3.8 0 0 0 17.5 2.7Zm0 1.6a.7.7 0 0 1 .7.7v.8h.8a.7.7 0 0 1 .694.605l.006.095a.7.7 0 0 1-.7.7h-.8V8a.7.7 0 0 1-.605.694L17.5 8.7a.7.7 0 0 1-.7-.7v-.8H16a.7.7 0 0 1-.694-.605L15.3 6.5a.7.7 0 0 1 .7-.7h.8V5a.7.7 0 0 1 .605-.694L17.5 4.3Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CartPlusLine);
